export const SET_ORGANIZATION_TREE_ITEMS = 'setOrganizationTreeItems'
export const SET_ORGANIZATION_TREE_PLACEHOLDER = 'setOrganizationTreePlaceholder'
export const SET_PREV_ORGANIZATION_TREE_ITEMS = 'setPrevOrganizationTreeItems'
export const SET_PREV_ORGANIZATION_TREE_PLACEHOLDER = 'setPrevOrganizationTreePlaceholder'
export const SET_SOURCE_ITEM_ID_AND_TYPE = 'setSourceItemIdAndType'
export const SET_DESTINATION_ITEM_ID_AND_TYPE = 'setDestinationItemIdAndType'
export const SET_SOURCE_ITEM = 'setSourceItem'
export const SET_DESTINATION_ITEM = 'setDestinationItem'
export const SET_ASIDE_BAR_HAS_CHANGED = 'setAsideBarHasChanged'
export const SET_LATEST_FULL_TREE = 'setLatestFullTree'
export const SET_IS_SEARCH_ACTIVE = 'setIsSearchActive'

const setOrganizationTreeItems = (state, payload) => {
    if (process.env.VUE_APP_DEBUG) {
        console.debug('OrganizationTree::setOrganizationTreeItems', payload)
    }
    state.organizationTreeItems = payload
}

const setOrganizationTreePlaceholder = (state, payload) => {
    if (process.env.VUE_APP_DEBUG) {
        console.debug('OrganizationTree::setOrganizationTreePlaceholder', payload)
    }
    state.organizationTreePlaceholder = payload
}

const setPrevOrganizationTreeItems = (state, payload) => {
    if (process.env.VUE_APP_DEBUG) {
        console.debug('OrganizationTree::setPrevOrganizationTreeItems', payload)
    }
    state.prevOrganizationTreeItems = payload
}

const setPrevOrganizationTreePlaceholder = (state, payload) => {
    if (process.env.VUE_APP_DEBUG) {
        console.debug('OrganizationTree::setPrevOrganizationTreePlaceholder', payload)
    }
    state.prevOrganizationTreePlaceholder = payload
}

const setSourceItemIdAndType = (state, payload) => {
    state.sourceItemIdAndType = payload
}

const setDestinationItemIdAndType = (state, payload) => {
    state.destinationItemIdAndType = payload
}

const setSourceItem = (state, payload) => {
    state.sourceItem = payload
}

const setDestinationItem = (state, payload) => {
    state.destinationItem = payload
}

const setAsideBarHasChanged = (state, payload) => {
    state.asideBarHasChanged = payload
}

const setLatestFullTree = (state, payload) => {
    if (process.env.VUE_APP_DEBUG) {
        console.debug('OrganizationTree::setLatestFullTree', payload)
    }
    state.latestFullTree = payload
}

const setIsSearchActive = (state, payload) => {
    state.isSearchActive = payload
}

export default {
    setOrganizationTreeItems,
    setOrganizationTreePlaceholder,
    setSourceItemIdAndType,
    setDestinationItemIdAndType,
    setSourceItem,
    setDestinationItem,
    setPrevOrganizationTreeItems,
    setPrevOrganizationTreePlaceholder,
    setAsideBarHasChanged,
    setLatestFullTree,
    setIsSearchActive
}
